var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.VACButton,{attrs:{"icon":"full-arrow-up","appearance":"secondary"},on:{"click":_setup.backToTop}})
}
var staticRenderFns = []

export { render, staticRenderFns }